export default "__VITE_ASSET__C725dekQ__"